export enum Collection {
    AUTH = "auth",
    USERS = "users",
    LICENSES = "licenses",
    DEVICES = "devices",
    ALERT_CONFIG = "alert-config",
    DEVICE_CMD = "device-cmd",
    FILES = "files",
    API_CONSUMERS = "api-consumers",
    DEVICE_ALARM = "device-alarm",    
    DEVICE_REPORTS = "device-reports",
    GEO_PCI = "geo-pci",
    GROUPS = "groups",
    DEVICE_GROUP = "device-group",
    PROFILE_TEMPLATE = "profile-template",
    RF_STANDARD = "rf-standard",
    ROLES = "roles",
    SCHEDULES = "Schedules",
    TAGS = "tags",
    TENANTS = "tenants",
    USAGES = "usages",
    WEBHOOK_SETTINGS = "webhook-settings"
};

export interface AuditCollection {
    name: string,
    value: Collection
};

export type CollectionNameMapping = {
    [key in Collection]: string;
}